import TermsConditions from './TermsConditions';

export default TermsConditions;
